import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'deepSearch'
})
export class DeepSearchPipe implements PipeTransform {

    private filteredArray = [];
    private currentCustomer: any = {};

    transform(array: any, queryString: string){
        this.filteredArray.length = 0;
        //return array.filter((element) => element.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0)
        if(queryString){
            this.searchRecursively(array, queryString);
            let stringifiedArray = this.filteredArray.map((el) => JSON.stringify(el));
            stringifiedArray = stringifiedArray.filter((el, index, self) => self.indexOf(el) == index);
            this.filteredArray = stringifiedArray.map((el) => JSON.parse(el));
            return this.filteredArray;
        }
        else {
            return array;
        }
    }   

    searchRecursively(array, queryString){
        array.forEach(el => {
            if(el.type && el.type.toLowerCase() == 'customer'){
                this.currentCustomer = el;
            }
            if (el.type && el.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
                if(el.type.toLowerCase() == 'customer'){
                    this.filteredArray.push(el);
                }
                else{
                    this.filteredArray.push(this.currentCustomer);
                }             
            }
            else {
                if(el.children && el.children.length > 0){
                    this.searchRecursively(el.children, queryString);
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/pipes/deep-search.pipe.ts